import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const log = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'id',
        //     sortDirections: ["descend", "ascend", 'descend']
        // },

        {
            title: '操作事件',
            dataIndex: 'event',
            key: 'event',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.event || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '操作类型',
            dataIndex: 'type',
            key: 'type',
            scopedSlots: {
                filterDropdown: 'filterType',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender:'type',
            },
            filteredValue: filteredInfo.type || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            // title: '方法返回信息',
            title: '操作状态',
            dataIndex: 'returnValue.msg',
            key: 'msg',
            scopedSlots: {
                customRender:'msg',
            },
        },
        {
            title: '操作人姓名',
            dataIndex: 'realName',
            key: 'realName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.realName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '操作时间',
            dataIndex: 'operateTime',
            key: 'operateTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        // {
        //     title: '事件ID',
        //     dataIndex:'eventIds',
        //     key: 'eventIds',
        //     scopedSlots: {
        //         customRender: 'eventIds'
        //     }
        // },

        // {
        //     title: '创建时间',
        //     dataIndex: 'createTime',
        //     key: 'createTime',
        //     sorter: true,
        //     sortDirections: ["descend", "ascend", "descend"]
        // },
        // {
        //     title: '创建人',
        //     dataIndex: 'createBy',
        //     key: 'createBy',
        //     scopedSlots: {
        //         filterDropdown: 'filterDropdown',
        //         filterIcon: 'filterIcon',
        //         filtered: true,
        //     },
        //     filteredValue: filteredInfo.createBy || [],
        //     sorter: true,
        //     sortDirections: ["descend", "ascend", "descend"]
        // },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
